import moment from 'moment';


// A helper function to extract database data into tables
// input: data:             database data, should be a json format
//        header:           the header of table
//        dataBaseHeader:   corresponding database header
// return: data for display tables
var groupingData = function(data, groupby) {

    if (data == null){
        return
    }
    var groups = {};
    data.forEach( ( o )=>
        {
          var group = JSON.stringify( groupby(o) );
          groups[group] = groups[group] || [];
          groups[group].push( o );  
        });
    return Object.keys(groups).map( function( group )
        {
          return groups[group]; 
        })
}

export { groupingData }





// WEBPACK FOOTER //
// ./src/util/grouping.js